var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBracketCurly(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M200 32H120C89.072 32 64 57.072 64 88V165.5C64 176.065 59.803 186.197 52.333 193.667L7 239C2.5 243.5 0 249.625 0 256C0 262.375 2.5 268.5 7 273L52.333 318.333C59.803 325.803 64 335.935 64 346.5V424C64 454.928 89.072 480 120 480H200C213.255 480 224 469.255 224 456V456C224 442.745 213.255 432 200 432H120C115.6 432 112 428.4 112 424V346.5C112 323.062 102.663 300.59 86.053 284.054L57.875 256L86.053 227.946C102.663 211.41 112 188.938 112 165.5V88C112 83.6 115.6 80 120 80H200C213.255 80 224 69.255 224 56V56C224 42.745 213.255 32 200 32Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBracketCurly);
export default __webpack_public_path__ + "static/media/bracket-curly.7ecec46a7c7f3bcbae3107208b833e3d.svg";
export { ForwardRef as ReactComponent };